import { usePostApiTimesheetsByUuidSubmitAsync, } from '../../generated/sitComponents';
import { invalidateTimesheetQuery, setTimesheetQueryData } from './query';
export function usePostTimesheetSubmitAsync(options) {
    return usePostApiTimesheetsByUuidSubmitAsync({
        ...options,
        onMutate: async (variables, context) => {
            const { id } = variables.pathParams;
            setTimesheetQueryData(context.client, id, (draft) => {
                draft.submitState = 'SUBMITTING';
                return draft;
            });
            options?.onMutate?.(variables, context);
        },
        onError: async (error, variables, onMutateResult, context) => {
            const { id } = variables.pathParams;
            await invalidateTimesheetQuery(context.client, id);
            setTimesheetQueryData(context.client, id, (draft) => {
                draft.submitState = 'NOT_SUBMITTING';
                return draft;
            });
            options?.onError?.(error, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-post-timesheet-submit.js.map